var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 42,
    viewBox: "0 0 132 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 25,
    height: 3,
    fill: "#ea7c69"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.5943 19.2569H37.5443C34.7943 19.2569 32.5443 20.0444 32.5443 21.0069C32.5443 21.9694 34.7943 22.7569 37.5443 22.7569H92.5943V25.8894C92.5943 26.6769 95.2943 27.0619 96.8443 26.5019L110.744 21.6194C111.694 21.2694 111.694 20.7269 110.744 20.3769L96.8443 15.4944C95.2943 14.9344 92.5943 15.3369 92.5943 16.1069V19.2569Z",
    fill: "#ea7c69"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashArrow);
export default __webpack_public_path__ + "static/media/DashArrow.06bc3b13.svg";
export { ForwardRef as ReactComponent };